import Main from "../components/layout/Main";
import Header from "../components/layout/Header";
import React, { useState, useMemo, useCallback} from "react";
import { get, post } from "../Libraries/Ajax/HttpService";
import { Modal, Spin, Checkbox } from "antd";
import {
  ReactFlow,
  ReactFlowProvider,
  Background,
  Controls,
  Handle,
  Position,
} from "reactflow";
import dagre from "dagre";
import "reactflow/dist/style.css";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import Meter from "../assets/images/meter.png";
import Tank from "../assets/images/tank.png";
import GPWell from "../assets/images/gpwell.png";
import WaterPlants from "../assets/images/water-plants.png";
import Pump from "../assets/images/pump.svg";
import Reservoir from "../assets/images/reservoir.svg";
import WaterMeter from "../assets/images/water-meter.png";
import { useDistrict } from "../utils/DistrictContext";
import {
  schematicJSON_Original,
  schematicJSON_District2,
  fixedPositions_Original,
  fixedPositions_District2,
} from "../utils/schematicData";
// ====================================================================
// 1. DATA AND ASSETS
// ====================================================================

const images = {
    meter: Meter,
    storage: Tank,
    source: GPWell,
    plant: WaterPlants,
    pump: Pump,
    reservoir: Reservoir,
    supply: WaterMeter,
    consumer: WaterMeter,
    process: WaterMeter,
   
};



const getLayoutedElements = (nodes, edges, direction = "TB", districtId) => {
    const g = new dagre.graphlib.Graph(); 
    g.setGraph({ rankdir: direction, nodesep: 300, ranksep: 380 }); 
    g.setDefaultEdgeLabel(() => ({}));
    

    nodes.forEach((n) => g.setNode(n.id, { width: 100, height: 80 }));
    edges.forEach((e) => g.setEdge(e.from, e.to));
    dagre.layout(g);

    // *** CONDITIONAL FIXED POSITIONS SELECTION ***
    const fixedPositions = districtId === 'FB151' 
        ? fixedPositions_District2 
        : fixedPositions_Original;
    
    const layoutedNodes = nodes.map((n) => {
        const pos = fixedPositions[n.id] || g.node(n.id); 
        return {
            id: n.id,
            position: { x: pos.x, y: pos.y },
            data: { label: n.label, type: n.type, name: n.name },
            type: "customNode",
        };
    });

//     const layoutedEdges = edges.map((e, i) => {
//         const markerEndSetting = e.markerEnd === undefined
//             ? { type: "arrowclosed", color: "#333" }
//             : e.markerEnd;
//     const isTargetEdge = (e.from === '206680' && e.to === 'non_potable_reservoir');
        
//         // Set the type: 'default' for Bezier curve, 'smoothstep' for others
//         const edgeType = isTargetEdge ? "default" : "smoothstep";
        
//         // Define the style (making it slightly thicker for distinction)
//         const edgeStyle = isTargetEdge 
//             ? { 
//                 stroke: "#333",      // Standard color
//                 strokeWidth: 3,      // Slightly thicker
//               }
//             : { 
//                 stroke: "#333", 
//                 strokeWidth: 2 
//               }; // Standard style
        
//         // Define source/target handles to force the R-L connection for the target edge
//         const sourceHandle = isTargetEdge ? "right-source" : null;
//         const targetHandle = isTargetEdge ? "left-target" : null;

//         return {
//             id: `e${i}`,
//             source: e.from,
//             target: e.to,
//             animated: true,
//             type: "smoothstep",
//             style: { stroke: "#333", strokeWidth: 2 },
//             markerEnd: markerEndSetting,
//             sourceHandle: sourceHandle,
//             targetHandle: targetHandle,
//         };
//     });
//     return { layoutedNodes, layoutedEdges };
// };

const layoutedEdges = edges.map((e, i) => {
        const markerEndSetting = e.markerEnd === undefined
            ? { type: "arrowclosed", color: "#333" }
            : e.markerEnd;
        
        // Target edge to force R-L connection for a specific node in District 2
        const isTargetEdge = (e.from === '206680' && e.to === 'non_potable_reservoir');
        
        // Set the type: 'default' for Bezier curve, 'smoothstep' for others
        const edgeType = isTargetEdge ? "default" : "smoothstep";
        
        // Define the style (making it slightly thicker for distinction)
        const edgeStyle = isTargetEdge 
            ? { 
                stroke: "#333",      // Standard color
                strokeWidth: 3,      // Slightly thicker
              }
            : { 
                stroke: "#333", 
                strokeWidth: 2 
              }; // Standard style
        
        // Define source/target handles to force the R-L connection for the target edge
        const sourceHandle = isTargetEdge ? "right-source" : null;
        const targetHandle = isTargetEdge ? "left-target" : null;

        return {
            id: `e${i}`,
            source: e.from,
            target: e.to,
            animated: true,
            type: edgeType, // FIX APPLIED: Used the calculated edgeType
            style: edgeStyle, // FIX APPLIED: Used the calculated edgeStyle
            markerEnd: markerEndSetting,
            sourceHandle: sourceHandle,
            targetHandle: targetHandle,
        };
    });
    return { layoutedNodes, layoutedEdges };
};
// ====================================================================
// 3. CUSTOM NODE COMPONENT 
// ====================================================================

const CustomNode = ({ id, data }) => { 
  const isPlant = data.type === "plant";
  const isNorthDistribution = id === "north_distribution_meter";
  const isSouthDistribution = id === "south_distribution_meter";
  const isICNode = id === "meter_150850" || id === "meter_150849";

  if (data.type === "structure") {
    return (
      <div
        style={{
          width: "1px",
          height: "1px",
          background: "transparent",
        }}
      >
        <Handle
          type="target"
          position={Position.Top}
          style={{ background: "#555", width: 8, height: 8 }}
        />
        <Handle
        type="target"
        position={Position.Left}
        id="left-target" // Unique ID is good practice
        style={{ background: "#555", left: 0, transform: 'translate(-50%, -50%)' }}
      />

      {/* Source Handle on the Right */}
      <Handle
        type="source"
        position={Position.Right}
        id="right-source" // Unique ID is good practice
        style={{ background: "#555", right: 0, transform: 'translate(50%, -50%)' }}
      />
      
        <Handle
          type="source"
          position={Position.Bottom}
          style={{ background: "#555", width: 8, height: 8 }}
        />
      </div>
    );
  }

  const imageSize = (() => {
    switch (data.type) {
      case "meter": return 100;
      case "storage": return 120;
      case "plant": return 140;
      case "source": return 120;
      case "pump": return 90;
      case "reservoir": return 110;
      case "supply":
      case "consumer":
      case "process":
      case "label": 
      case "structure":
        return 0;
      default: return 80;
    }
  })();

  const isCOHLabel = id === "coh"; 

  return (
    <div style={{ textAlign: "center", cursor: ["meter", "consumer", "supply", "process"].includes(data.type)
      ? "pointer"
      : "default",display: "flex",
    flexDirection: "column",
    alignItems: "center"}}>
      <Handle
        type="target"
        position={Position.Top}
        style={{ background: "#555" }}
      />
      {images[data.type] && (
        
        <div
            style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                transform: isPlant ? "scale(1)" : "scale(1)",
                alignItems: "center",
            }}
        >
          <img
            src={images[data.type]}
            width={imageSize}
            alt=""
            style={{
              height: "auto",
              display: "block",
            }}
          />
        </div>
      )}

      <div
        style={
          isCOHLabel
            ? {
                fontSize: "18px",
                fontWeight: "bold",
                marginTop: "8px",
                background: "transparent",
                padding: "4px",
                borderRadius: "6px",
                width: "140px",
                boxShadow: "none",
                position: "relative", 
              }
            : {
                fontSize: "20px",
                fontWeight: "bold",
                marginTop: data.type === "plant" ? "15px" : "8px",
                background: "#fff",
                padding: "4px 8px",
                borderRadius: "6px",
                width: "140px",
                textAlign: "center",
                boxShadow: "0 2px 4px rgba(0,0,0,0.3)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "relative", 
                marginLeft: data.label === "Water Plant" ? "20px" : "0px",
              }
        }
      >
        <span
          style={{
            fontSize:
              data.type === "plant" ? "18px" : isCOHLabel ? "24px" : data.label.length > 8 ? "19px" : "20px",
            fontWeight: "bold",
          }}
        >
          {data.label}
        </span>
      
      </div>
        {(isNorthDistribution || isSouthDistribution) && (
        <div
          style={{
            marginTop: "8px",
            backgroundColor: "#d9eaff",
            borderRadius: "4px",
            padding: "2px 6px",
            fontSize: "16px",
            fontWeight: "bold",
            width: "140px", 
            textAlign: "center",
          }}
        >
          {isNorthDistribution ? "North Distribution Meter" : "South Distribution Meter"}
        </div>
      )}
      {isICNode && (
        <div
          style={{
            position: "absolute",
            left: "-60px", 
            top: "50%", 
            transform: "translateY(-50%)",
            backgroundColor: "#d9eaff",
            padding: "2px 6px",
            borderRadius: "4px",
            fontWeight: "bold",
            fontSize: "16px",
          }}
        >
          IC
        </div>
      )}
      <Handle
        type="source"
        position={Position.Bottom}
        style={{ background: "#555" }}
      />
    </div>
  );
};


// ====================================================================
// 4. MAIN COMPONENT (With Prop)
// ====================================================================

/**
 * Renders the water schematic for a given district.
 * @param {object} props
 * @param {'original' | 'district2'} props.districtId 
 */
const Schematicsdynamic = () => { // Step 1: Remove the districtId prop here
 
  const [isSingleModalOpen, setIsSingleModalOpen] = useState(false);
  const [singleMeterData, setSingleMeterData] = useState(null);
  const [isAlertEnabled, setIsAlertEnabled] = useState(false);
  const [regNo, setRegNo] = useState("");
  const [multiModalNodeType, setMultiModalNodeType] = useState(null);
  const [isMultiModalOpen, setIsMultiModalOpen] = useState(false);
  const [multiMeterData, setMultiMeterData] = useState(null);
  const [modalTitle, setModalTitle] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Step 2: Use the value from the hook and assign it to 'districtId'
  const districtIdvalue = useDistrict(); 
  const districtId = districtIdvalue?.selectedDistrict;
  const currentSchematicJSON = districtId === 'FB151' 
    ? schematicJSON_District2 
    : schematicJSON_Original;
    
  const minZoomValue = useMemo(() => {
    return districtId === 'FB151' ? 0.5 : 0.4;
  }, [districtId]);
    
  
  const fitViewOptionsValue = useMemo(() => {
    
    if (districtId === 'FB151') {
      return { padding: 0.05, includeHiddenNodes: true };
    }
    
    return { padding: 0.2, includeHiddenNodes: true };
  }, [districtId]);
  const multiApiNodeNames = useMemo(() => {
     if (districtId === 'FB151') {
      return ["Total_Supply", "Total_Demand", "D2_Tank"]; 
    }
    return ["Produced", "NPS(P1)", "NPS(P2)"]; 
  }, [districtId]);

 
  const { layoutedNodes, layoutedEdges } = useMemo(
    () => getLayoutedElements(currentSchematicJSON.nodes, currentSchematicJSON.edges, "TB", districtId),
    // Dependency array updated to correctly re-calculate when data changes
    [districtId, currentSchematicJSON] 
  );

  const nodeTypes = useMemo(() => ({ customNode: CustomNode }), []);

  
 
  const handleSingleMeterClick = useCallback(async (node) => {
    setLoading(true);
    setIsSingleModalOpen(true);
    setError(null);
    setSingleMeterData(null);
    const meter_id = node.data.name;
    const user = JSON.parse(localStorage.getItem("MCData"));
    const userid = user?.userid;

    try {
      const response = await get(`apis/schematic_meter?meter_id=${meter_id}&user_id=${userid}`);
      const mainRes = response.data.data;
      setSingleMeterData(mainRes);
      setRegNo(mainRes?.register_number || "");
      setIsAlertEnabled(mainRes?.meter_notification_active?.notification_status || false);
    } catch (e) {
      console.error("Error fetching single meter data:", e);
      setError("Failed to load meter data. Please try again.");
    } finally {
      setLoading(false);
    }
  }, []);


  const handleMultiMeterClick = useCallback(async (node) => {
    setLoading(true);
    setIsMultiModalOpen(true);
    setError(null);
    setMultiMeterData(null);
    setModalTitle(node.data.label);
    setMultiModalNodeType(node.data.type); 
    try {
      const response = await get(`apis/schematic_meter?total_flow=${node.data.name}`);
      const resData = response?.data?.data;
      if (!resData) throw new Error("Invalid API response structure");

      setMultiMeterData({
        totalUsage: resData.total_sum || 0,
        unit: resData.unit || "Gallons",
        flowData: resData?.meter_flow?.map(x => ({ name: x.option, Flow: x.flow })) || [],
        meters: resData?.data_meters || [],
      });
    } catch (e) {
      console.error("Error fetching multi-meter data:", e);
      setError("Failed to load flow data. Please try again.");
    } finally {
      setLoading(false);
    }
  }, []);

  
  const onNodeClick = useCallback((_, node) => {
    const nodeName = node.data.name;
    if (multiApiNodeNames.includes(nodeName)) {
      handleMultiMeterClick(node);
    } else if (node.data.type === "meter") {
      handleSingleMeterClick(node);
    }

    else if (node.data.type === "consumer" || node.data.type === "process" || node.data.type === "supply") {
      handleMultiMeterClick(node);
    }
  }, [handleSingleMeterClick, handleMultiMeterClick, multiApiNodeNames]);

  
  const handleSingleModalCancel = () => setIsSingleModalOpen(false);
  const handleMultiModalCancel = () => setIsMultiModalOpen(false);

  const handleAlertChange = (e) => {
    const isChecked = e.target.checked;
    setIsAlertEnabled(isChecked);
    const user = JSON.parse(localStorage.getItem("MCData"));
    const meter_id = e.target.id;
    
    post(
      `apis/notification_meters_update?user_id=${user?.userid}&meter_id=${meter_id}&account_name=${singleMeterData?.overided_name}&status=${isChecked}&register_number=${regNo}`
    );
  };

  const StatusBadge = ({ status, impact }) => {
    if (!status || status.length === 0) {
      return <span className="badge bg-success">Good</span>;
    }
    return status.map((item, index) => {
      let className = "rednoti";
      if (item === "Status is good") {
        className = "badge bg-success";
      }
      else if (impact <= 0.2) className = "yellownoti";
      else if (impact <= 0.4) className = "orangenoti";
      return <><span key={index} className={className}>{item}</span>
        <br /></>
    });
  };

 

 
  return (
    <>
      <Header />
      <Main className="bg-white"><div
          style={{
             width: "100%",
             height: "calc(100vh - 64px)", 
             border: "1px solid #ccc",
             backgroundColor: "#fff",
          }}
        >
        
            <ReactFlowProvider>
            
            <ReactFlow
             key={districtId}
              nodes={layoutedNodes}
                edges={layoutedEdges}
              nodeTypes={nodeTypes}
              fitView
              //   fitViewOptions={{ padding: 0.2, includeHiddenNodes: true }}
              // minZoom={0.4}
              fitViewOptions={fitViewOptionsValue} 
              minZoom={minZoomValue} 
              maxZoom={1}
              onNodeClick={onNodeClick}
              proOptions={{ hideAttribution: true }}
            >
              <Background />
                <Controls
                showZoom={true}
                showInteractive={false}
                style={{
                  zIndex: 1000,
                  top: 10,
                  left: 10,
                  bottom: 1000,
                  pointerEvents: "none",
                }}
                className="custom-controls"
              />
            </ReactFlow>
          </ReactFlowProvider>
                      
         
          {isSingleModalOpen && (
            <Modal
              width={800}
              open={isSingleModalOpen}
              onCancel={handleSingleModalCancel}
              footer={null}
              centered
            >
              {loading && <div className="text-center p-5"><Spin size="large" /></div>}
              {error && <div className="text-center p-5 text-danger">{error}</div>}
              {!loading && !error && singleMeterData && (
                <>
                  <div className="d-flex justify-content-between align-items-center p-3">
                    <div>
                      <h5 className="text-blue mb-0">Meter Usage</h5>
                      <p className="mb-0">[Last 30 Days]</p>
                    </div>
                    <h5>{singleMeterData.total_sum?.toLocaleString()}
                      </h5>
                  </div>
                  <ResponsiveContainer width="100%" height={300}>
                    <LineChart data={singleMeterData.meter_flow?.map(x => ({ name: x.option, Flow: x.flow }))}>
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="name" />
                      <YAxis label={{ 
                      value: 'Gallons', 
                      angle: -90,      
                      position: 'insideLeft', 
                      dy: 30,         
                      style: { textAnchor: 'middle' ,fill: '#8884d8'} 
                      }} />
                      <Tooltip formatter={(value) => value.toLocaleString()} />
                      <Legend />
                      <Line type="monotone" dataKey="Flow" stroke="#8884d8" activeDot={{ r: 8 }} />
                    </LineChart>
                    
                  </ResponsiveContainer>
                  <div className="p-3">
                    <div className="bg-light rounded d-flex justify-content-between align-items-center">
                        <span><strong>Meter ID:</strong> {singleMeterData.meter_id}</span>
                        <Checkbox id={singleMeterData.meter_id} onChange={handleAlertChange} checked={isAlertEnabled}>
                            Add to alert
                        </Checkbox>
                    </div>
                    <div className="mt-2"><strong>Status:</strong> <StatusBadge status={singleMeterData.status} impact={singleMeterData.impact} /></div>
                     <div className="text-black px-1 my-2 included-outliers  bg-gray d-flex justify-content-between">
                        <div>Account Name </div>
                        <div className="popupalignment"> {singleMeterData.overided_name}</div>
                      </div>
                    <div className="text-black px-0 included-outliers bg-gray" style={{ position: "relative" }}>
                    <span style={{ position: "relative", left: "-8px", display: "inline-block" }}>
                    Location Address
                   </span>
                   </div>

                      <div>
                        <div>{singleMeterData?.location_address_line1}</div>
                         <div>{singleMeterData?.location_address_line2}</div>
                        <div>{singleMeterData?.location_city}, {singleMeterData.location_state} {singleMeterData.location_zip}</div>
                      </div>
                  </div>
                </>
              )}
            </Modal>
          )}

       
          {isMultiModalOpen && (
            <Modal
              width={800}
              open={isMultiModalOpen}
              onCancel={handleMultiModalCancel}
              footer={null}
              centered
            >
              {loading && <div className="text-center p-5"><Spin size="large" /></div>}
              {error && <div className="text-center p-5 text-danger">{error}</div>}
              {!loading && !error && multiMeterData && (
                <>
                  <div className="d-flex justify-content-between align-items-center p-3">
                    <div>
                        <h5 className="text-blue mb-0"> {multiModalNodeType === "meter" ? "Total Flow" : modalTitle}</h5>
                        {/* <h5 className="text-blue mb-0">{modalTitle}</h5> */}
                        
                        <p className="mb-0">[Last 30 Days]</p>
                    </div>
                    <h5>{multiMeterData.totalUsage?.toLocaleString()} 
                      </h5>
                  </div>
                  <ResponsiveContainer width="100%" height={300}>
                      <LineChart data={multiMeterData.flowData}>
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis dataKey="name" />
                          <YAxis label={{ 
                          value: 'Gallons', 
                          angle: -90,      
                          position: 'insideLeft', 
                          dy: 30,         
                          style: { textAnchor: 'middle',fill: '#8884d8' } 
                      }} />
                          <Tooltip formatter={(value) => value.toLocaleString()} />
                          <Legend />
                          <Line type="monotone" dataKey="Flow" stroke="#8884d8" activeDot={{ r: 8 }} />
                      </LineChart>
                      {/* <div className="labelYAxis6">Gallons</div> */}
                  </ResponsiveContainer>
                  
                   
                    {(["supply", "consumer", "process"].includes(multiModalNodeType)) && (
                      <div className="row p-3">
                      {multiMeterData.meters.map((meter, index) => (
                        <div className="col-md-6" key={index}>
                          <div className="border rounded p-2 h-100">
                            <div className="bg-light  rounded"><strong>Meter ID:</strong> {meter.meter_id}</div>
                            <div className="mt-2"><strong>Status:</strong> <StatusBadge status={meter.status} impact={meter.impact} /></div>
                            <div className="text-black px-1 my-2 included-outliers  bg-gray d-flex justify-content-between">
                          <div>Account Name </div>
                          <div className="popupalignment"> {meter.overided_name}</div>
                        </div>
                       <div className="text-black px-0 included-outliers bg-gray" style={{ position: "relative" }}>
                       <span style={{ position: "relative", left: "-8px", display: "inline-block" }}>
                        Location Address
                       </span>
                      </div>

                        <div>
                              <div>{meter?.location_address_line1}</div>
                               <div>{meter?.location_address_line2}</div>
                              <div>{meter.location_city}, {meter.location_state} {meter.location_zip}</div>
                            </div>
                          </div>
                        </div>
                      ))}
                      </div>)}
                </>
              )}
            </Modal>
          )}
        </div>
      </Main>
    </>
  );
};

export default Schematicsdynamic;